import * as AdminProjectsModule from './index';

export const Admin_AllProjects = {
  path: '/admin/projects/all',
  name: 'AdminAllProjects',
  component: AdminProjectsModule.AllProjects,
};

export const Admin_CancelledProjects = {
  path: '/admin/projects/cancelled',
  name: 'AdminCancelledProjects',
  component: AdminProjectsModule.CancelledProjects,
};

export const Admin_CompletedProjects = {
  path: '/admin/projects/completed',
  name: 'AdminCompletedProjects',
  component: AdminProjectsModule.CompletedProjects,
};

export const Admin_DeletedProjects = {
  path: '/admin/projects/deleted',
  name: 'AdminDeletedProjects',
  component: AdminProjectsModule.DeletedProjects,
};

export const Admin_DraftProjects = {
  path: '/admin/projects/drafts',
  name: 'AdminDraftProjects',
  component: AdminProjectsModule.DraftProjects,
};

export const Admin_PublishedProjects = {
  path: '/admin/projects/published',
  name: 'AdminPublishedProjects',
  component: AdminProjectsModule.PublishedProjects,
};

export const Admin_StartedProjects = {
  path: '/admin/projects/started',
  name: 'AdminStartedProjects',
  component: AdminProjectsModule.StartedProjects,
};
